import {HTTP, ERROR} from '@/http-common';
import Vue from 'vue';
import router from '../../router/index';

const state = {
  body: '',
  loading: false,
  massMessages: [],
  resultsCount: 0
}

const mutations = {
  SUBMIT_MASS_MESSAGES_MESSAGE_SUCCESS(state) {
  },
  SET_MASS_MESSAGES(state, data) {
    state.massMessages = data
  },
  SET_MASS_MESSAGES_RESULTS_COUNT(state, data) {
    state.resultsCount = data
  },
}

const getters = {
  getMassMessagesData: state => state.massMessages,
  getResultsCount: state => state.resultsCount
}

const actions = {
  SUBMIT_MASS_MESSAGES_MESSAGE_ACTION: ({commit}, payload) => {
    state.loading = true;
    payload.context.start();
    HTTP.post(`mass-messages/send`, {participant_ids: payload.data.participant_ids, body: payload.data.body})
      .then(response => {
        if (response.data.status === 'success') {
          commit('SUBMIT_MASS_MESSAGES_MESSAGE_SUCCESS');
          let all = response.data.data.message.all;
          let success = response.data.data.message.success;
          Vue.prototype.$notify(success + ' of ' + all + ' message(s) sent.');
          state.loading = false;
        } else {
          Vue.prototype.$notify({type: 'error', text: response.data.message});
          state.loading = false
        }
        payload.context.stop();
        router.push({name: 'Dashboard'});
      }).catch(err => {
      console.log(err);
      payload.context.stop();
      state.loading = false
    })
  },
  GET_MASS_MESSAGES_ACTION: ({commit}, payload) => {
    state.loading = true
    HTTP.post(`mass-messages/search`, payload)
      .then(response => {
        ERROR(response)
        if (response.status === 200) {
          commit('SET_MASS_MESSAGES', response.data.data.data);
          commit('SET_MASS_MESSAGES_RESULTS_COUNT', response.data.data.results_num);
          state.loading = false
        }
      }).catch(err => {
      console.log(err)
      state.loading = false
    })
  },
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/massMessages.js